import React, { useEffect, useState } from "react";
import { AppContext } from "./App";
import MessageInfo from "./common/MessageInfo";
import { SeoContext } from "./data/seo/SeoContextProvider";
import { fetchOriginalPath } from "./data/seo/seoUtils";
import { concatUrlPathnames } from "./data/sport-utils";
import { getConfiguration } from './data/utils/configuration';
import { appConfig } from "./appConfig";

function RouteSeoPath(props) {
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    //const [message,setMessage] = useState(null);

    useEffect(function() {
        if(getConfiguration().seo){
            //console.log("no-matching for" +props.location.pathname)
            const pathname = concatUrlPathnames(appConfig.BASENAME,props.location.pathname);
            //const originalPath = fetchOriginalPath(props.location.pathname,true);
            const originalPath = fetchOriginalPath(pathname,true);
            if(originalPath){
                appContext.setSeoRoutePath(props.location.pathname,originalPath);
                //setMessage('')
            }else{
                //setMessage('Page not found');
                appContext.setPageNotFound(true);
            }
        }
        seoContext.setShowHtmlContainer(false);
    }, []);


    return (
        <>
        {/* {message && 
        <MessageInfo message={message}/>
        } */}
        </>
    )
}

export default RouteSeoPath;